"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_mapper_1 = require("4d-mapper");
const material_1 = require("@angular/material");
const app_service_1 = require("../../commons/app.service");
const AppBaseComponent_1 = require("../../commons/AppBaseComponent");
const router_1 = require("@angular/router");
const application_events_service_1 = require("../../xs/services/events/application-events.service");
const acl_service_1 = require("../../commons/acl/acl.service");
class AddUserDialog extends AppBaseComponent_1.AppBaseComponent {
    constructor(dialogRef, data, fourD, service, router, acl, snackBar, dialog, applicationEvents) {
        super(service, router, snackBar, dialog, applicationEvents);
        this.dialogRef = dialogRef;
        this.data = data;
        this.fourD = fourD;
        this.service = service;
        this.router = router;
        this.snackBar = snackBar;
        this.dialog = dialog;
        this.mod = {};
        this.projects = [];
        this.projectsHash = {};
        this.projects = fourD.projects;
    }
    ok() {
        if (!/\S+@\S+\.\S+/.test(this.mod.email)) {
            this.openSnackBarError('SIGNIN.EMAIL_INVALID');
            return;
        }
        this.mod.projects = Object.keys(this.projectsHash).filter(k => this.projectsHash[k]).map(k => parseInt(k));
        this.dialogRef.close({ group: this.group, user: this.mod });
    }
    cancel() {
        this.dialogRef.close();
    }
    updateState() {
        this.showProjects = !this.group.uid.endsWith('_admins');
    }
}
exports.AddUserDialog = AddUserDialog;
